import React from "react";
// import CoursesImage1 from "../Assets/Slide3/Aboutimage.png";
import CoursesImage1 from "../Assets/Adm.png";
// import CoursesImage2 from "../Assets/Exam Cell/linkurl00.png";
import CoursesImage3 from "../Assets/Examcell/linkurl11.png";
import CoursesImage4 from "../Assets/Examcell/linkurl22.png";
import CoursesImage2 from "../Assets/Examcell/linkurl33.png";
const ExamCell = () => {
  return (
    <div className="w-full overflow-hidden p-5">
<h1 className='text-center  font-bold text-3xl pt-7'>Exam Announcements</h1>
      <hr
        className="section-divider my-1 border-[#D3D3D3]  mx-auto pb-5"
        style={{ width: "17%" }}
      />
      {/* Full width main image */}
      <img
        src={CoursesImage1} 
        alt="Full Width Display"
        className="w-full  object-cover mb-4 sm:w-full md:w-[95%] lg:w-full xl:w-full 2xl:w-full"
      />
      {/* Grid for 4 images */}
      <div className="grid grid-cols-1   sm:grid-cols-2 gap-4 pl-[10%] pr-[5%] sm:pr-[5%] md:pr-[10%] lg:pr-[5%] xl:pr-[5%] 2xl:pr-[5%]">
        <a href="https://apsbtet.ap.gov.in/#!/index">
        <img
          src={CoursesImage2}
          alt="Image 2"
          className="w-[90%]  object-cover "
        />
        </a>
        <a href="https://sbtet.ap.gov.in/APSBTET/">
        <img
          src={CoursesImage3}
          alt="Image 3"
          className="w-[90%]  object-cover"
        />
        </a>
        <a href="https://apsbtet.net/studentportal/screens/mainstudentinfo.aspx">
        <img
          src={CoursesImage4}
          alt="Image 4"
          className="w-[90%]  object-cover"
        />
        </a>
        <a href="https://sbtet.ap.gov.in/APSBTET/results.do">
        <img
          src={CoursesImage3}
          alt="Image 2"
          className="w-[90%]  object-cover "
        />
        </a>
         {/* <div className="w-full h-48">
          <iframe
            src="http://www.srijyothipolytechnic.com/docs/EOA Report%202022-23 (1).pdf"
            width="100%"
            height="100%"
            title="PDF Display"
          />
        </div> */}
      </div>
    </div>
  );
};
export default ExamCell;